export default __webpack_public_path__ + "static/media/appleAppStoreSpanish.bb91fdc5.png";